import { type CollectionChainType } from '../../client/common/structs/daas/v2/common/chains';
export function normalizeUrl(url: string, prefix?: string) {
    prefix = prefix ?? `${window.location.protocol}//`;

    if (!/^https?:\/\//.test(url)) {
        return new URL(`${prefix}//${url}`);
    }

    return new URL(url);
}

export function getCollectionEthUrl(slug = '', chain?) {
    // TODO: This address needs to allow `eth` segment to be customized.
    return slug.length ? `/collection/${chain}/${slug}` : undefined;
}

type NftDetailsUrlType = {
    contractAddress: string;
    goBackEnabled?: boolean;
    tokenId: string;
    chain?: CollectionChainType;
};

export const getNftDetailsUrl = ({ contractAddress, tokenId, goBackEnabled, chain }: NftDetailsUrlType) => {
    let suffix = '';
    const search = {};

    if (goBackEnabled) {
        search['goBack'] = '1';
    }

    if (Object.keys(search).length) {
        suffix = `?${new URLSearchParams(search).toString()}`;
    }

    // TODO: Cannot access the `enum` without causing a `lexical declaration`
    // error. Not sure the root cause, but likely due to circular dependencies
    // within the `@app/client` folder.
    const fallbackChainSegment: CollectionChainType | 'Ethereum' = chain || 'Ethereum';

    return `/collectible/${fallbackChainSegment.toLowerCase()}/${contractAddress}/${tokenId}${suffix}`;
};

export const _generateUrl = (prefix, url) => {
    return (prefix.indexOf('://') === -1 ? `${prefix}://` : prefix) + url;
};
